<template>
  <page-outline :title="$t('administration.profile_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button></back-button>
      </b-row>
      <form-accordion :title="$t('administration.profile_info')"  :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="libelle" isMandatory
              :inputLabel="$t('administration.label')" :placeholderValue="$t('administration.label')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion :title="$t('administration.right')"  :isTitleUpperCase="false">
        <b-row>
          <b-col sm="4" class="form-group"  v-for="result in rights" :key="result">
            <!-- <label>
              {{ $t('administration.right') }}
            </label>
            <b-col sm="6" cols="6"> -->
              <!-- <select class="form-control" id="sel4" v-model="select_rights" readonly multiple> -->
                <b-form-checkbox v-model="select_rights"
                    :value="result">
                    {{ $t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result) }}
                </b-form-checkbox>
              <!-- </select> -->
            <!-- </b-col> -->
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="changeProfil()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"


import {loadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'AddProfilCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
  },
  props: ['idCompany'],
  data () {
    return {
      libelle: '',
      redirection: this.$engine.firstOn().company.redirection,
      rights: [],
      select_rights: []
    }
  },
  created () {
    this.rights = this.$engine.firstOn().company.rightsL
  },
  methods: {
    changeProfil () {
      let that = this
      this.$engine.firstOn().profilcompany.addProfil(
        this.idCompany,
        this.libelle,
        this.select_rights
      ).then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.add_profile'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/company/' + that.redirection})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    }
  }
}
</script>
